import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [CommonModule, TranslocoModule],
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent {
  // Empty default so the template falls back to the localized "Loading…".
  @Input() message: string = '';
}
